let utils = {
  addDomainToPath: function (path) {
    const host = (process.env.NODE_ENV === 'production')
      ? process.env.FRONTEND_HOST : location.origin

    if (path[0] === '#') { // hash mode join
      return host + location.pathname + (location.query || '') + path
    } else if (path[0] === '/') { // absolute path
      return host + path
    } else { // relative path
      return host + location.pathname.replace(/\/[^/]+$/, '/') + path
    }
  },
  getDefaultMetaTags: function ({
    description = '',
    path = '',
    title = '',
    imageUrl = '',
    imageWidth = null,
    imageHeight = null
  }) {
    let metaTags = [
      { name: 'description', content: description },
      { name: 'twitter:card', content: 'summary' },
      { name: 'twitter:site', content: '@stylegold2' },
      { name: 'og:type', content: 'website' },
      { name: 'og:url', content: this.addDomainToPath(path) },
      { name: 'og:title', content: title },
      { name: 'og:description', content: description },
      { name: 'og:image', content: imageUrl },
      { name: 'og:site_name', content: 'stylegold.by' },
      { name: 'og:locale', content: 'ru_BY' },
      { name: 'og:image:width', content: imageWidth },
      { name: 'og:image:height', content: imageHeight }
    ]
    return metaTags.filter(tag => tag.content)
  }
}

export default utils



// WEBPACK FOOTER //
// ./src/pages/utils.js